export default __webpack_public_path__ + "static/media/fMaltoBuza10.f7eb5277.png";